import { toAbsoluteUrl } from "src/_metronic/helpers";
import SVG from "react-inlinesvg";
const CellCheck = ({ isTrue }: { isTrue: boolean }) => {
    return (
        <>
            {isTrue ? (
                <div className="w-100 h-100 d-flex justify-content-center">
                    <SVG
                        width="16px"
                        fill="var(--kt-text-success)"
                        src={toAbsoluteUrl("/media/icons/duotune/general/tick.svg")}
                    />
                </div>
            ) : (
                <div className="w-100 h-100 d-flex justify-content-center">
                    <SVG
                        fill="var(--kt-text-danger)"
                        width="16px"
                        src={toAbsoluteUrl("/media/icons/duotune/general/cross.svg")}
                    />
                </div>
            )}
        </>
    );
};

export default CellCheck;
